var _path, _rect, _rect2, _rect3, _path2, _rect4, _path3, _path4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSsd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.75H44C46.2091 24.75 48 26.5409 48 28.75V36.75H18C15.7909 36.75 14 34.9591 14 32.75V25.75",
    stroke: "#00C7FD",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 18.75,
    width: 2.5,
    height: 2.5,
    fill: "#00C7FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 39.75,
    width: 2.5,
    height: 2.5,
    fill: "#00C7FD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 39.75,
    width: 2.5,
    height: 2.5,
    fill: "#00C7FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3667 15.75H56.75V41.25C56.75 43.4591 54.9591 45.25 52.75 45.25H4.75V22.25",
    stroke: "#00C7FD",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 3.5,
    height: 3.5,
    fill: "#00C7FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.4935L6 17.4939V22.2504H3.5V17.4935Z",
    fill: "url(#paint0_linear_242_7301)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3784 14.5L11.378 17L6.50325 17L6.50325 14.5L11.3784 14.5Z",
    fill: "url(#paint1_linear_242_7301)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 23,
    width: 3.5,
    height: 3.5,
    fill: "#00C7FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_242_7301",
    x1: 4.75,
    y1: 22.25,
    x2: 4.75,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_242_7301",
    x1: 11.3784,
    y1: 15.75,
    x2: 6.25,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7FD",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsd);
export default __webpack_public_path__ + "static/media/ssd.b255add21ce2e320918c39ce94448420.svg";
export { ForwardRef as ReactComponent };